import api, { unwrapList } from './api';
const tripService = {
  getAll:   (p)     => api.get('/trips/', { params: p }).then(r => unwrapList(r.data)),
  getById:  (id)    => api.get(`/trips/${id}/`).then(r => r.data),
  create:   (d)     => api.post('/trips/', d).then(r => r.data),
  update:   (id, d) => api.patch(`/trips/${id}/`, d).then(r => r.data),
  delete:   (id)    => api.delete(`/trips/${id}/`),
  declare:  (id, d) => api.post(`/trips/${id}/declare/`, d).then(r => r.data),
  summary:  (p)     => api.get('/trips/summary/', { params: p }).then(r => r.data),
};
export default tripService;